// extracted by mini-css-extract-plugin
export default {"active":"b3JpsR","inactive":"c3JpsR"};